<template>
  <div class="dreambooks">
    <!-- menu -->
    <nav class="horoscope__nav horoscope-nav" :class="{'sticky': sticky}">
      <div class="container horoscope-nav__container">
        <div class="row no-gutters horoscope-nav__row">
          <a
            href="#"
            role="button"
            class="horoscope-nav__item"
            @click.prevent="openFirstMenu = !openFirstMenu"
            :class="{'zindex': openFirstMenu}"
          >
            <img src="../assets/img/mayan.png" alt="Гороскоп древних Майя">
          </a>
          <a
            href="#"
            role="button"
            class="horoscope-nav__item horoscope-nav__item--active"
            @click.prevent="openSecondMenu = !openSecondMenu"
            :class="{'zindex': openSecondMenu}"
          >
            <img src="../assets/img/mayan/maya.png" alt="Календарь Майя">
          </a>
        </div>

        <transition name="fade">
          <nav
            class="horoscope__menu horoscope-menu horoscope-menu--first"
            v-if="openFirstMenu"
            @click="openFirstMenu = !openFirstMenu"
          >
            <router-link
              v-for="(item, index) in firstMenu"
              :key="index"
              :to="`/horoscope/${item.id}/`"
              :class="{'router-link-exact-active': routePath.indexOf(`/${item.id}/`) !== -1 ? true : false}"
            >
              <img :src="require(`../assets/img/${item.id}.png`)" :alt="item.name">
              {{item.name}}
            </router-link>
          </nav>
        </transition>

        <transition name="fade">
          <nav
            class="horoscope__menu horoscope-menu horoscope-menu--second"
            v-if="openSecondMenu"
            @click="openSecondMenu = !openSecondMenu"
          >
            <router-link
              v-for="(item, index) in mayaThirdMenu"
              :key="index"
              :to="`/horoscope/mayan/${item.id}.html`"
            >
              <img :src="require(`../assets/img/mayan/maya.png`)" :alt="item.name">
              {{item.name}}
            </router-link>
          </nav>
        </transition>
      </div>
      <transition name="fade">
        <div class="overlay" v-if="openFirstMenu" @click="openFirstMenu = false"></div>
      </transition>
      <transition name="fade">
        <div class="overlay" v-if="openSecondMenu" @click="openSecondMenu = false"></div>
      </transition>
    </nav>
    <!-- /menu -->
    <div class="container" :class="{'sticky-next': sticky}">
      <Loader v-if="loading"/>
      <template v-else>
        <div class="dreambooks__breadcrumbs">Календарь Майя</div>
        <div class="row">
          <div class="col mb-3">
            <div class="dreambooks__img">
              <img src="../assets/img/mayan/maya.png" alt="Календарь Майя">
            </div>
            <div class="dreambooks__text">
              <p>Много-много лет тому назад, когда европейцы только строили догадки о существовании Америки, а открывший ее Колумб еще не родился на свет, на территории современных Мексики, Гватемалы и Гондураса существовала огромная могущественная страна. Ее населяли индейцы майя. Полторы тысячи лет назад они уже умели строить города, возводить дворцы и храмы.</p>
              <p>Некоторые храмы служили майя обсерваториями, они наблюдали оттуда за движением Солнца, Луны и других небесных тел.Майя были замечательными строителями, скульпторами, резчиками по дереву и камню, но в этом они не выделялись среди других народов, например древних римлян, греков, китайцев или персов, которые тоже были большими умельцами. А вот в знании астрономии и математики в ту эпоху майя не имели себе равных.В VI веке правители майя приняли календарь, который оказался точнее всех солнечных календарей, когда-либо существовавших. Он вернее и того календаря, которым пользуемся мы с вами, . григорианского. Каким-то чудом, не имея ни космических спутников, ни телескопов, майя вычислили продолжительность солнечного года с точностью до секунд. Судите сами.</p>
              <p>В современной астрономии продолжительность солнечного года (см. статью СОЛНЕЧНЫЙ ГОД) составляет 365,2422 дня.Юлианский календарь, по которому до сих пор живет православная церковь, насчитывает в году 365, 2510 дня.</p>
              <p>По григорианскому календарю год составляет 365, 2425 дня.Год по календарю майя равнялся 365, 2420 дня, то есть всего на две десятитысячных доли отличался от современных данных.</p>
              <p>В году было 18 месяцев по двадцать дней. Месяц носил название .виналь.. 18 виналей составляли тун, то есть год. А один тун равнялся 360 кинам (дням). Последние пять дней года не входили в календарь. Майя считали их неблагоприятными. Последняя пятидневка года так и называлась: .ваайеб. . неблагоприятная. Майя говорили, что в эти дни .год умирает., и ничего не делали, потому что ничего хорошего все равно не получится.</p>
              <p>Год для майя был главной мерой времени. 20 лет составляли катун, 20 катунов . бактун, 20 бактунов . пиктун, 20 пиктунов . калабтун и так далее. В самый большой период времени, называвшийся алаутун, входило 23 040 000 000 кинов.</p>
              <p>Год майя начинался 16 июля. Этому дню соответствовал первый день месяца Поп. А заканчивался год 10 июля, в последний день месяца Кумху. Пять дней между этими числами как раз и составляли ваайеб.Счет времени майя вели с четвертого тысячелетия до нашей эры. С 3113 или, по другим расчетам, с 3373 года до нашей эры.</p>
              <p>Кроме солнечного календаря, который назывался хааб, у майя был лунный календарь под названием цолкин. Вместе два этих календаря образовывали период в 18 890 дней. И только по завершении этого цикла название и номер дня в календаре повторялись.</p>
              <p>Конечно, для создания такого сложного календаря нужна была очень хорошая система счета. И майя ею владели. В чем-то она походила на ту десятиричную систему, которой пользуемся мы с вами и которую европейцы заимствовали у арабов, в свою очередь перенявших ее у персов и индусов. Это девять цифр от 1 до 9 и ноль.</p>
              <p>У майя была двадцатиричная система счета. В ее основе лежал знак 0, который сам по себе ничего не означает, но в сочетании с другими цифрами увеличивает их в десятки раз. Ноль, расположенный слева, увеличивал в десять раз; когда майя ставили ноль сверху, это означало увеличение в двадцать раз.</p>
              <p>А вот цифр у майя было всего две, они изображались точкой и чертой. С помощью трех этих знаков майя умели рассчитывать орбиты планет, время затмений Солнца и Луны и всякие другие события на много лет вперед.</p>
            </div>
          </div>
        </div>
      </template>
    </div>
    <div class="container">
      <div class="row">
        <div class="col">
          <router-link to="/horoscope/mayan/" class="back-link">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              version="1.1"
              id="Capa_1"
              x="0px"
              y="0px"
              viewBox="0 0 31.494 31.494"
              style="enable-background:new 0 0 31.494 31.494;"
              xml:space="preserve"
              width="15px"
              height="15px"
            >
              <path
                d="M10.273,5.009c0.444-0.444,1.143-0.444,1.587,0c0.429,0.429,0.429,1.143,0,1.571l-8.047,8.047h26.554  c0.619,0,1.127,0.492,1.127,1.111c0,0.619-0.508,1.127-1.127,1.127H3.813l8.047,8.032c0.429,0.444,0.429,1.159,0,1.587  c-0.444,0.444-1.143,0.444-1.587,0l-9.952-9.952c-0.429-0.429-0.429-1.143,0-1.571L10.273,5.009z"
                fill="#ff00a4"
              ></path>
            </svg>
            Вернуться на главную раздела
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loader from "@/components/Loader.vue";
import setSticky from "../setSticky.js";
export default {
  components: {
    Loader
  },
  data() {
    return {
      routePath: this.$route.path,
      openFirstMenu: false,
      openSecondMenu: false,
      sticky: false
    };
  },
  metaInfo () {
    return {
      title: 'Календарь и хронология Майя - Календарь Майа на ORAKUL.com',
      meta: [
        { name: 'description', content: 'Календарь и хронология племени Майя. Описание календаря Майя, хронология древних Майя на портале гороскопов ORAKUL.com' },
        { name: 'keywords', content: 'календарь майя, календарь майа, древняя цивилизация майя, индейцы майа, календари' }
      ]
    }
  },
  computed: {
    mayan() {
      return this.$store.state.horoscope.mayan;
    },
    firstMenu() {
      return this.$store.state.horoscope.firstMenu;
    },
    mayaThirdMenu() {
      return this.$store.state.horoscope.mayaThirdMenu;
    },
    loading() {
      return this.$store.state.horoscope.loading;
    }
  },
  created() {
    setSticky.call(this);
  }
};
</script>

<style lang="scss" scoped>
.horoscope-nav__item:first-child img {
  width: 65px;
}

.dreambooks__img {
  width: 160px;
  float: left;
  margin-right: 10px;
  margin-bottom: 5px;
  img {
    display: block;
    max-width: 100%;
    height: auto;
  }
}

.dreambooks__text {
  font-size: 18px;
  line-height: 24px;
  font-weight: 400;
  color: #333;
  .link {
    font-weight: 400;
  }
}
.dreambooks__breadcrumbs {
  font-size: 18px;
  font-weight: 700;
  color: #000;
  margin-bottom: 20px;
}

.dreambooks__select-title {
  padding: 20px 15px;
  font-size: 18px;
  font-weight: 700;
  line-height: 20px;
}

.dreambooks__select-title--gray {
  background: #f1f4f6;
  color: #333;
}

.dreambooks__select-title--pink {
  background: #f9f1fe;
  color: #511079;
}

.dreambooks__select-item {
  margin-bottom: 25px;
}

.dreambooks__list {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  padding: 7px;
  width: 100%;
  overflow: hidden;
  &::after {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    content: "";
  }
  a {
    color: #511079;
    font-size: 18px;
    line-height: 18px;
    font-weight: 400;
    border: 2px solid transparent;
    display: block;
    text-align: center;
    width: calc(100% / 8);
    padding: 15px 3px;
    text-decoration: none;
    &:hover {
      text-decoration: none;
    }
    &.router-link-exact-active {
      color: #000;
      border-radius: 3px;
      border: 2px solid #ff00a4;
    }
    img {
      display: block;
      width: 50px;
      height: auto;
      margin: 0 auto;
      position: relative;
      left: 7px;
      // margin-bottom: 7px;
      // border-radius: 50%;
      // box-shadow: 0 0 8px 4px #ccd6db;
    }
  }
}
.dreambooks__list--words {
  justify-content: space-between;
  a {
    display: block;
    width: 49%;
    text-align: left;
    word-break: break-word;
    -webkit-hyphens: auto;
    -moz-hyphens: auto;
    -ms-hyphens: auto;
    hyphens: auto;
    padding: 5px 3px;
  }
}

.dreambooks__list--nemu a {
  color: #777;
  font-size: 10px;
  line-height: 10px;
  font-weight: 700;
  border: 2px solid transparent;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 33%;
  padding: 10px 3px;
  text-decoration: none;
  &:hover {
    text-decoration: none;
  }
  &.router-link-exact-active {
    color: #000;
    border-radius: 3px;
    border: 2px solid #ff00a4;
  }
  i {
    margin-bottom: 7px;
  }
}
.dreambooks__list--gray {
  background: #f1f4f6;
  &::after {
    box-shadow: 0 -80px 60px 60px #6d90a1;
  }
}
.dreambooks__list--pink {
  background: #f9f1fe;
  &::after {
    box-shadow: 0 -80px 60px 60px #c67af5;
  }
}
</style>

